import html, { htmlAttributes } from "decorator-shared/html";
import type { IconProps } from "./types";

export const ChevronRightIcon = ({
  ariaLabel,
  ...props
}: IconProps = {}) => html`
  <svg
    ${htmlAttributes({ ariaHidden: ariaLabel ? "false" : "true", ...props })}
    ${ariaLabel ? html`aria-label="${ariaLabel}"` : ""}
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    focusable="false"
    role="img"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M9.47 5.97a.75.75 0 0 1 1.06 0l5.5 5.5a.75.75 0 0 1 0 1.06l-5.5 5.5a.75.75 0 1 1-1.06-1.06L14.44 12 9.47 7.03a.75.75 0 0 1 0-1.06"
      clip-rule="evenodd"
    />
  </svg>
`;
